/* Possible exports: colorOptions, getRandomColor, calculateNextButtonLabel */

export const colorOptions = [
    '#f44336', '#ff5722', '#e2851f', '#ff9800', '#ffeb3b', '#cddc39', '#617c08', '#4a7017',
    '#8bc34a', '#48e52e', '#2e8b57', '#4caf50', '#3faa68', '#00fcaa', '#009688', '#00bcd4',
    '#33b5de', '#03a9f4', '#2196f3', '#3f51b5', '#786ed6', '#5e3ff5', '#673ab7', '#a168f4',
    '#9c27b0', '#d93385', '#e91e63', '#ff0000', '#ff6d00', '#ffda00', '#b6ff00', '#00ff24',
    '#0091ff', '#47321F', '#707070', '#000000' 
  ];
  
  export function getRandomColor() {
    const randomIndex = Math.floor(Math.random() * colorOptions.length);
    return colorOptions[randomIndex];
  }

  export function calculateNextButtonLabel(shapes) {
    if (!shapes || !Array.isArray(shapes)) return 1;
  
    const assignedLabels = shapes
      .flatMap(shape => shape?.buttons?.map(button => button.buttonLabel) || [])
      .filter(Boolean)
      .map(label => Number(label)) // Ensure labels are numbers
      .sort((a, b) => a - b);
  
    let nextLabel = 1;
    for (let i = 0; i < assignedLabels.length; i++) {
      if (assignedLabels[i] !== nextLabel) break;
      nextLabel++;
    }
  
    return nextLabel;
  }